import { render, staticRenderFns } from "./AuthorizationDialog.vue?vue&type=template&id=23b42726&scoped=true&"
import script from "./AuthorizationDialog.vue?vue&type=script&lang=js&"
export * from "./AuthorizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationDialog.vue?vue&type=style&index=0&id=23b42726&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b42726",
  null
  
)

component.options.__file = "AuthorizationDialog.vue"
export default component.exports